import * as z from "zod";
//#region src/__generated__/project-gge/role/zod/assignUserWithRoleSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const assignUserWithRolePathRoleIdSchema = z.uuid();
const assignUserWithRolePathProjectIdSchema = z.uuid();
const assignUserWithRoleQueryUserIdSchema = z.uuid();
const assignUserWithRoleStatus200Schema = z.unknown();
const assignUserWithRoleResponseSchema = assignUserWithRoleStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/role/zod/projectRoleRightDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectRoleRightDtoSchema = z.object({
	id: z.uuid().optional(),
	rightType: z.enum([
		"READ_TASK_CLASSIFIER_DATA",
		"DONE_TASK_CLASSIFIER_DATA",
		"APPROVE_TASK_CLASSIFIER_DATA",
		"CONFIRM_TASK_CLASSIFIER_DATA",
		"CREATE_TAB",
		"CREATE_AND_APPROVE_DATA_REQUEST",
		"DELETE_DATA_REQUEST",
		"UPDATE_DATA_REQUEST",
		"CREATE_DATA_RESPONSE",
		"READ_TASK_DICTIONARY_DATA",
		"DONE_TASK_DICTIONARY_DATA",
		"APPROVE_TASK_DICTIONARY_DATA",
		"CONFIRM_TASK_DICTIONARY_DATA",
		"CREATE_BUILDING_OBJECT",
		"UPDATE_BUILDING_OBJECT",
		"DELETE_BUILDING_OBJECT",
		"APPROVE_BUILDING_OBJECT",
		"READ_TASK_DOCUMENT",
		"DONE_TASK_DOCUMENT",
		"APPROVE_TASK_DOCUMENT",
		"CONFIRM_TASK_DOCUMENT",
		"CREATE_ATTRIBUTE_DATA",
		"APPROVE_ATTRIBUTE_DATA",
		"READ_TASK_COST",
		"DONE_TASK_COST",
		"APPROVE_TASK_COST",
		"CONFIRM_TASK_COST",
		"UPDATE_COST",
		"DELETE_COST",
		"READ_TASK_CALENDAR",
		"DONE_TASK_CALENDAR",
		"APPROVE_TASK_CALENDAR",
		"CONFIRM_TASK_CALENDAR",
		"UPDATE_CALENDAR",
		"DELETE_CALENDAR",
		"READ_TASK_BUILDING_MANAGEMENT",
		"DONE_TASK_BUILDING_MANAGEMENT",
		"APPROVE_TASK_BUILDING_MANAGEMENT",
		"CONFIRM_TASK_BUILDING_MANAGEMENT",
		"SET_MEASURE_RESULT",
		"SET_MEASURE_RESULT_COORDS",
		"CREATE_TASK",
		"UPDATE_TASK",
		"REQUEST_TASK_APPROVE",
		"APPROVE_EXPERT",
		"UPDATE_EXPERT_TASK",
		"CREATE_EXPERT_SOLUTION_ELEMENT",
		"UPDATE_EXPERT_SOLUTION_ELEMENT",
		"DELETE_EXPERT_SOLUTION_ELEMENT",
		"DOWNLOAD_IFC",
		"READ_CLIPPING",
		"MODIFY_CLIPPING",
		"READ_IOT",
		"MODIFY_IOT",
		"READ_CLASSIFIER_DATA_REQUEST_ENTITY_TAB_COMMENT",
		"CREATE_CLASSIFIER_DATA_REQUEST_ENTITY_TAB_COMMENT",
		"UPDATE_CLASSIFIER_DATA_REQUEST_ENTITY_TAB_COMMENT",
		"DELETE_CLASSIFIER_DATA_REQUEST_ENTITY_TAB_COMMENT",
		"READ_CLASSIFIER_DATA_REQUEST_ENTITY_REQUEST_COMMENT",
		"CREATE_CLASSIFIER_DATA_REQUEST_ENTITY_REQUEST_COMMENT",
		"UPDATE_CLASSIFIER_DATA_REQUEST_ENTITY_REQUEST_COMMENT",
		"DELETE_CLASSIFIER_DATA_REQUEST_ENTITY_REQUEST_COMMENT",
		"READ_CLASSIFIER_DATA_REQUEST_ENTITY_RESPONSE_COMMENT",
		"CREATE_CLASSIFIER_DATA_REQUEST_ENTITY_RESPONSE_COMMENT",
		"UPDATE_CLASSIFIER_DATA_REQUEST_ENTITY_RESPONSE_COMMENT",
		"DELETE_CLASSIFIER_DATA_REQUEST_ENTITY_RESPONSE_COMMENT",
		"READ_DICTIONARY_DATA_REQUEST_ENTITY_REQUEST_COMMENT",
		"CREATE_DICTIONARY_DATA_REQUEST_ENTITY_REQUEST_COMMENT",
		"UPDATE_DICTIONARY_DATA_REQUEST_ENTITY_REQUEST_COMMENT",
		"DELETE_DICTIONARY_DATA_REQUEST_ENTITY_REQUEST_COMMENT",
		"READ_DICTIONARY_DATA_REQUEST_ENTITY_BUILDING_OBJECT_COMMENT",
		"CREATE_DICTIONARY_DATA_REQUEST_ENTITY_BUILDING_OBJECT_COMMENT",
		"UPDATE_DICTIONARY_DATA_REQUEST_ENTITY_BUILDING_OBJECT_COMMENT",
		"DELETE_DICTIONARY_DATA_REQUEST_ENTITY_BUILDING_OBJECT_COMMENT",
		"READ_DOCUMENT_ATTRIBUTE_COMMENT",
		"CREATE_DOCUMENT_ATTRIBUTE_COMMENT",
		"UPDATE_DOCUMENT_ATTRIBUTE_COMMENT",
		"DELETE_DOCUMENT_ATTRIBUTE_COMMENT",
		"READ_DOCUMENT_ATTRIBUTE_DATA_COMMENT",
		"CREATE_DOCUMENT_ATTRIBUTE_DATA_COMMENT",
		"UPDATE_DOCUMENT_ATTRIBUTE_DATA_COMMENT",
		"DELETE_DOCUMENT_ATTRIBUTE_DATA_COMMENT",
		"READ_MARKUP_TASK_ENTITY_COMMENT",
		"CREATE_MARKUP_TASK_ENTITY_COMMENT",
		"UPDATE_MARKUP_TASK_ENTITY_COMMENT",
		"DELETE_MARKUP_TASK_ENTITY_COMMENT",
		"READ_BUILDING_MANAGEMENT_TASK_COMMENT",
		"CREATE_BUILDING_MANAGEMENT_TASK_COMMENT",
		"UPDATE_BUILDING_MANAGEMENT_TASK_COMMENT",
		"DELETE_BUILDING_MANAGEMENT_TASK_COMMENT",
		"READ_BUILDING_MANAGEMENT_TASK_EXPERT_COMMENT",
		"CREATE_BUILDING_MANAGEMENT_TASK_EXPERT_COMMENT",
		"UPDATE_BUILDING_MANAGEMENT_TASK_EXPERT_COMMENT",
		"DELETE_BUILDING_MANAGEMENT_TASK_EXPERT_COMMENT"
	]).optional().describe("Тип доступа к сервису."),
	serviceType: z.enum([
		"CLASSIFIER_DATA",
		"DICTIONARY_DATA",
		"DOCUMENT",
		"DICTIONARY_CALC_COST",
		"DICTIONARY_CALC_CALENDAR",
		"BUILDING_MANAGEMENT",
		"BUILDING_MEASURE",
		"MODELS_SERVICE",
		"VIEWER_SERVICE",
		"COMMENT_SERVICE",
		"GEOMETRY_SERVICE",
		"PROJECT_SERVICE",
		"TASK_TRACKER_SERVICE",
		"FILES_SERVICE",
		"RUNNER_SERVICE",
		"CAMUNDA_SERVICE",
		"MODEL_REPOSITORY_SERVICE",
		"CONTRACTOR_MANAGEMENT_SERVICE",
		"ONTOLOGY_SERVICE",
		"MODEL_PROCESSING_SERVICE",
		"KNOWLEDGE_BASE_SERVICE"
	]).optional().describe("Сервис, к которому разрешен доступ.")
}).describe("Сущность права доступа внутри роли.");
//#endregion
//#region src/__generated__/project-gge/role/zod/projectRoleDtoSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const projectRoleDtoSchema = z.object({
	id: z.uuid().optional(),
	isGlobal: z.boolean().optional(),
	name: z.string().describe("Название роли."),
	rights: z.array(projectRoleRightDtoSchema).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" }).optional().describe("Список прав доступа роли.")
}).describe("Сущность проектной роли.");
//#endregion
//#region src/__generated__/project-gge/role/zod/createGlobalProjectRoleSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const createGlobalProjectRoleStatus200Schema = projectRoleDtoSchema.describe("Сущность проектной роли.");
const createGlobalProjectRoleResponseSchema = createGlobalProjectRoleStatus200Schema;
const createGlobalProjectRoleDataSchema = projectRoleDtoSchema.omit({ isGlobal: true }).describe("Сущность проектной роли.");
//#endregion
//#region src/__generated__/project-gge/role/zod/createLocalProjectRoleSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const createLocalProjectRolePathProjectIdSchema = z.uuid();
const createLocalProjectRoleQueryUserIdSchema = z.uuid().optional();
const createLocalProjectRoleStatus200Schema = projectRoleDtoSchema.describe("Сущность проектной роли.");
const createLocalProjectRoleResponseSchema = createLocalProjectRoleStatus200Schema;
const createLocalProjectRoleDataSchema = projectRoleDtoSchema.omit({ isGlobal: true }).describe("Сущность проектной роли.");
//#endregion
//#region src/__generated__/project-gge/role/zod/getGlobalProjectRolesSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getGlobalProjectRolesStatus200Schema = z.array(projectRoleDtoSchema);
const getGlobalProjectRolesResponseSchema = getGlobalProjectRolesStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/role/zod/getProjectRoleByIdSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const getProjectRoleByIdPathRoleIdSchema = z.uuid();
const getProjectRoleByIdStatus200Schema = projectRoleDtoSchema.describe("Сущность проектной роли.");
const getProjectRoleByIdResponseSchema = getProjectRoleByIdStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/role/zod/removeRoleWithUserFromProjectSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const removeRoleWithUserFromProjectPathRoleIdSchema = z.uuid();
const removeRoleWithUserFromProjectPathProjectIdSchema = z.uuid();
const removeRoleWithUserFromProjectPathUserIdSchema = z.uuid();
const removeRoleWithUserFromProjectStatus200Schema = z.unknown();
const removeRoleWithUserFromProjectResponseSchema = removeRoleWithUserFromProjectStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/role/zod/removeUserFromProjectSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const removeUserFromProjectPathProjectIdSchema = z.uuid();
const removeUserFromProjectPathUserIdSchema = z.uuid();
const removeUserFromProjectStatus200Schema = z.unknown();
const removeUserFromProjectResponseSchema = removeUserFromProjectStatus200Schema;
//#endregion
//#region src/__generated__/project-gge/role/zod/updateGlobalProjectRoleRightsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updateGlobalProjectRoleRightsPathGlobalRoleIdSchema = z.uuid();
const updateGlobalProjectRoleRightsStatus200Schema = projectRoleDtoSchema.describe("Сущность проектной роли.");
const updateGlobalProjectRoleRightsResponseSchema = updateGlobalProjectRoleRightsStatus200Schema;
const updateGlobalProjectRoleRightsDataSchema = z.array(projectRoleRightDtoSchema).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" });
//#endregion
//#region src/__generated__/project-gge/role/zod/updateProjectRoleRightsSchema.ts
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/
const updateProjectRoleRightsPathRoleIdSchema = z.uuid();
const updateProjectRoleRightsStatus200Schema = projectRoleDtoSchema.describe("Сущность проектной роли.");
const updateProjectRoleRightsResponseSchema = updateProjectRoleRightsStatus200Schema;
const updateProjectRoleRightsDataSchema = z.array(projectRoleRightDtoSchema).refine((items) => new Set(items).size === items.length, { message: "Array entries must be unique" });
//#endregion
export { createGlobalProjectRoleStatus200Schema as A, createLocalProjectRoleDataSchema as C, createLocalProjectRoleStatus200Schema as D, createLocalProjectRoleResponseSchema as E, assignUserWithRoleQueryUserIdSchema as F, assignUserWithRoleResponseSchema as I, assignUserWithRoleStatus200Schema as L, projectRoleRightDtoSchema as M, assignUserWithRolePathProjectIdSchema as N, createGlobalProjectRoleDataSchema as O, assignUserWithRolePathRoleIdSchema as P, getGlobalProjectRolesStatus200Schema as S, createLocalProjectRoleQueryUserIdSchema as T, removeRoleWithUserFromProjectStatus200Schema as _, updateGlobalProjectRoleRightsDataSchema as a, getProjectRoleByIdStatus200Schema as b, updateGlobalProjectRoleRightsStatus200Schema as c, removeUserFromProjectResponseSchema as d, removeUserFromProjectStatus200Schema as f, removeRoleWithUserFromProjectResponseSchema as g, removeRoleWithUserFromProjectPathUserIdSchema as h, updateProjectRoleRightsStatus200Schema as i, projectRoleDtoSchema as j, createGlobalProjectRoleResponseSchema as k, removeUserFromProjectPathProjectIdSchema as l, removeRoleWithUserFromProjectPathRoleIdSchema as m, updateProjectRoleRightsPathRoleIdSchema as n, updateGlobalProjectRoleRightsPathGlobalRoleIdSchema as o, removeRoleWithUserFromProjectPathProjectIdSchema as p, updateProjectRoleRightsResponseSchema as r, updateGlobalProjectRoleRightsResponseSchema as s, updateProjectRoleRightsDataSchema as t, removeUserFromProjectPathUserIdSchema as u, getProjectRoleByIdPathRoleIdSchema as v, createLocalProjectRolePathProjectIdSchema as w, getGlobalProjectRolesResponseSchema as x, getProjectRoleByIdResponseSchema as y };

//# sourceMappingURL=updateProjectRoleRightsSchema2.js.map